__webpack_require__.p = "https://static-1306521133.cos.ap-beijing.myqcloud.com/paifu/paifu-console/build/";